import { useQuery } from '@tanstack/react-query';
import { punchcardService } from '../services/punchcardService';
import { punchcardKeys } from './queryKeys';
import type { AgreementInfo } from '../types';

export function useAgreementInfo(agreementUuid: string | undefined) {
  return useQuery<AgreementInfo>({
    queryKey: punchcardKeys.agreementInfo(agreementUuid ?? ''),
    queryFn: () => punchcardService.getAgreementInfo(agreementUuid!),
    enabled: !!agreementUuid,
  });
}
